<template>
  <div class="escalation-wrapper">
    <b-card no-body>
      <molecule-escalation-stepper
        :current-step="currentStep"
        :is-disable-next-button="isDisableNextButton"
        :is-disable-submit-button="isShowValidate && !!invalidLevels.length"
        :text-submit-btn="escalationTemplateId ? 'Save Changes' : 'Create'"
        @onClickPreviousStepBtn="clickPreviousStepBtn"
        @onClickNextStepBtn="clickNextStepBtn"
        @onClickSubmitBtn="displayModal"
      >
        <template #first-step-content>
          <div class="row">
            <div class="col-12 col-md-6">
              <atom-input
                v-model="templateData.templateName"
                title="Escalation Template Name"
                placeholder="Template Name"
                :isAsterisk="true"
              ></atom-input>
            </div>

            <div
              v-if="templateData.templateId"
              class="col-7 col-md-4 mt-1 mt-md-0"
            >
              <label for="">Escalation Template Status</label>
              <div class="d-flex align-items-center custom-margin-top-10">
                <b-badge
                  pill
                  :variant="statusVariant"
                  class="d-flex text-capitalize"
                  >{{ statusTemplate }}</b-badge
                >
                <!-- <div
                  class="d-block d-md-none suspend-button ml-1"
                  @click="clickActiveTemplate"
                >
                  <span class="font-size-12">{{ textActiveButton }} </span>
                </div> -->
              </div>
            </div>

            <div
              v-if="templateData.templateId"
              class="col-5 col-md-2 d-flex align-items-end justify-content-end"
            >
              <div class="d-flex">
                <atom-button
                  buttonId="suspend-button-id"
                  buttonStyle="border"
                  :buttonColor="styleActiveButton"
                  @click="clickActiveTemplate"
                  >{{ textActiveButton }}</atom-button
                >
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12">
              <atom-text-area
                v-model="templateData.templateDescription"
                title="Description"
                placeholder="Description"
                :rows="5"
                :isAsterisk="true"
                errorMessage="Description is required"
              ></atom-text-area>
            </div>
          </div>
        </template>
        <template #second-step-content>
          <div
            class="row align-items-md-center flex-column-reverse flex-md-row"
          >
            <div class="col-12 col-md-6">
              <atom-input
                v-model="templateData.templateName"
                title="Escalation Template Name"
                placeholder="Template Name"
                :isAsterisk="true"
                isDisable
              ></atom-input>
            </div>
            <div v-if="templateData.templateId" class="col-12 col-md-6 mt-md-0">
              <div
                class="mt-1 d-flex justify-content-end justify-content-md-start text-capitalize"
              >
                <b-badge pill :variant="statusVariant">{{
                  statusTemplate
                }}</b-badge>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12">
              <atom-text-area
                v-model="templateData.templateDescription"
                title="Description"
                placeholder="Description"
                errorMessage="Description is required"
                :rows="5"
                :isAsterisk="true"
                isDisable
              ></atom-text-area>
            </div>
          </div>

          <div v-if="criteriaList.length">
            <molecule-criteria-detail
              v-for="(_criteriaItem, index) in criteriaList"
              :key="index"
              v-model="criteriaList[index]"
              :level="index + 1"
              :total-item="criteriaList.length"
              :escalation-template-id="escalationTemplateId"
              :is-escalate="templateData.isEscalate"
              :user-options="userOptions"
              :is-show-validate="isShowValidate"
              :email-options="criteriaList[index].emailOptions"
              :phone-options="criteriaList[index].phoneOptions"
              @upLevel="handleUpLevel"
              @downLevel="handleDownLevel"
              @removeLevel="handleRemoveLevel"
              @isErrorLevel="handleErrorLevel"
              @changeContractName="changeContractName"
            />
          </div>

          <div v-if="!templateData.isEscalate" class="d-flex">
            <atom-button
              buttonId="add-new-level"
              class="mt-2"
              @click="handleAddNewLevel"
            >
              <feather-icon icon="PlusIcon" size="14" />
              Add New Level
            </atom-button>
          </div>
        </template>
      </molecule-escalation-stepper>
    </b-card>

    <footer style="padding-top: 1px" />

    <!-- confirm -->
    <molecule-modal-dialog
      :modalId="modalConfirmCreate"
      :isTextCenter="true"
      icon="AlertCircleIcon"
      :textTitle="`Do you want to create “${this.templateData.templateName}”?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="submitEscalation"
    ></molecule-modal-dialog>

    <molecule-modal-dialog
      :modalId="modalConfirmSave"
      :isTextCenter="true"
      icon="AlertCircleIcon"
      :textTitle="`Do you want to save “${this.templateData.templateName}”?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="submitEscalation"
    ></molecule-modal-dialog>
  </div>
</template>

<script>
import { BBadge, BCard } from "bootstrap-vue"

import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import { DateTime } from "luxon"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeEscalationStepper from "@/components/molecules/portal/escalation/MoleculeEscalationStepper.vue"
import MoleculeCriteriaDetail from "@/components/molecules/portal/escalation/MoleculeCriteriaDetail.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixins from "@/mixins"

export default {
  name: "OrganismCreateEditTemplate",
  components: {
    BBadge,
    BCard,
    AtomButton,
    AtomInput,
    AtomTextArea,
    MoleculeEscalationStepper,
    MoleculeCriteriaDetail,
    MoleculeModalDialog,
  },
  mixins: [mixins, mixinsValidator],
  props: {
    escalationTemplateId: {
      type: [String, null],
      required: false,
      default: null,
    },
    value: {
      type: Object,
      required: true,
    },
    userOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    internalUserData: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      currentStep: 1,

      defaultCriteriaData: {
        id: null,
        contactName: null,
        contactRole: "",
        contactEmail: null,
        contactPhone: null,
        escalationTimeSummary: null,
        escalationTimeDays: null,
        escalationTimeHours: null,
        escalationTimeMinutes: null,
        enableSystemNotification: false,
        enableEmailNotification: false,
        emailAddress: "",

        emailOptions: [],
        phoneOptions: [],
      },
      invalidLevels: [],

      modalConfirmCreate: "confirm-create-escalation",
      modalConfirmSave: "confirm-save-escalation",

      isShowValidate: false,
    }
  },

  computed: {
    templateData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    criteriaList() {
      return this.templateData.criteria
    },
    isDisableNextButton() {
      return (
        !this.templateData?.templateName?.trim() ||
        !this.templateData?.templateDescription?.trim()
      )
    },
    statusTemplate() {
      return this.templateData.status.toLowerCase()
    },
    isActiveTemplate() {
      return this.templateData.status === "ACTIVE"
    },
    statusVariant() {
      return this.isActiveTemplate ? "light-success" : "light-secondary"
    },
    textActiveButton() {
      return this.isActiveTemplate ? "Suspend" : "Enable"
    },
    styleActiveButton() {
      return this.isActiveTemplate ? "secondary" : "success"
    },
  },

  methods: {
    clickActiveTemplate() {
      this.templateData.status = this.isActiveTemplate ? "SUSPENDED" : "ACTIVE"
      this.$emit("updateEscalation", this.templateData)
    },
    clickNextStepBtn() {
      this.currentStep = 2
    },
    clickPreviousStepBtn() {
      this.currentStep = 1
    },

    handleAddNewLevel() {
      this.templateData.criteria.push({
        ...this.defaultCriteriaData,
        id: `NewLevel-${DateTime.now()}`,
      })
    },

    handleRemoveLevel(level) {
      const index = level - 1
      this.templateData.criteria.splice(index, 1)

      const indexRemove = this.invalidLevels.indexOf(level)
      this.invalidLevels.splice(indexRemove, 1)
    },

    handleUpLevel(level, item) {
      const formIndex = level - 1
      const toIndex = formIndex - 1

      this.templateData.criteria.splice(formIndex, 1)
      this.templateData.criteria.splice(toIndex, 0, item)
    },

    handleDownLevel(level, item) {
      const formIndex = level - 1
      const toIndex = formIndex + 1

      this.templateData.criteria.splice(formIndex, 1)
      this.templateData.criteria.splice(toIndex, 0, item)
    },

    handleErrorLevel(isErrorLevel, level) {
      if (isErrorLevel && !this.invalidLevels.includes(level)) {
        this.invalidLevels.push(level)
      }

      if (!isErrorLevel && this.invalidLevels.includes(level)) {
        const index = this.invalidLevels.indexOf(level)
        this.invalidLevels.splice(index, 1)
      }
    },

    displayModal() {
      this.isShowValidate = true
      if (!this.invalidLevels.length) {
        if (this.escalationTemplateId) {
          this.$bvModal.show(this.modalConfirmSave)
        } else {
          this.$bvModal.show(this.modalConfirmCreate)
        }
      }
    },

    submitEscalation() {
      if (this.escalationTemplateId) {
        this.$emit("updateEscalation", this.templateData)
      } else {
        this.$emit("createNewEscalation", this.templateData)
      }
    },

    changeContractName(selectedOption, level) {
      if (selectedOption.username) {
        const selectedUserData = this.internalUserData.find(
          (item) => item.username === selectedOption?.username
        )
        const emailOptions = selectedUserData?.emails
        const phoneOptions = selectedUserData?.phones

        this.criteriaList[level - 1].contactRole = selectedUserData?.groups
          ?.map((g) => g.groupName)
          .join(", ")
        this.criteriaList[level - 1].emailOptions = emailOptions
        this.criteriaList[level - 1].phoneOptions = phoneOptions

        const primaryEmail = emailOptions?.find((item) => item.isPrimary)
        const primaryPhone = phoneOptions?.find((item) => item.isPrimary)

        this.criteriaList[level - 1].contactEmail = primaryEmail
        this.criteriaList[level - 1].emailAddress = primaryEmail
        this.criteriaList[level - 1].contactPhone = primaryPhone
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.escalation-wrapper::v-deep .dropdown-toggle-no-caret {
  padding: 6px;
}
.suspend-button {
  color: #b9b9c3;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #ff9f43;
  }
}

.justify-self-end {
  justify-self: end;
}
</style>
